import React from 'react';
import ReactDOM from "react-dom/client";

import { persistor, store } from 'app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';

import { theme } from './app/style/theme';
import PublicRouter from 'app/routes/PublicRouter';
import { PersistGate } from 'redux-persist/integration/react';
import { Font } from '@react-pdf/renderer';
import RobotoRegular from 'assets/roboto/Roboto-Regular.ttf';
import RobotoBold from 'assets/roboto/Roboto-Bold.ttf';
import { ThemeProvider as StylesThemeProvider } from '@mui/styles';
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material';

/**
 * Fonts for PDF
 */
Font.register({
    family: 'Roboto',
    fonts: [
        { src: RobotoRegular, fontWeight: 'normal' },
        { src: RobotoBold, fontWeight: 'bold' }
    ]
});

//persistor.purge();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <React.StrictMode>
        <MuiThemeProvider theme={theme}>
            <StylesThemeProvider theme={theme}>
                <StyledEngineProvider injectFirst>
                    {/* <CssBaseline /> */}
                    <Provider store={store}>
                        <PersistGate persistor={persistor}>
                            <PublicRouter />
                        </PersistGate>
                    </Provider>
                </StyledEngineProvider>
            </StylesThemeProvider>
        </MuiThemeProvider>
    </React.StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
